import React from 'react'
import { Link } from 'react-router-dom'

const linkCls = "inline-flex flex-auto font-semibold text-left no-underline select-none border border-[#D0D0D0] rounded-[10px] bg-[#253D90] text-[12.5px] leading-normal mx-[5px] my-[5px] min-h-[2.75em] outline-none px-[10px] py-[10px] text-[#FAFAFA] transition-all duration-300 ease-[cubic-bezier(.23,1,0.32,1)] hover:text-[#FAFAFA] hover:bg-[#12186B]"

// Fuente única (Res. MinTIC 1519/2020): canales de atención en el portal de ICETEX.
const CANALES_URL = 'https://web.icetex.gov.co/atencion-y-servicios-a-la-ciudadania/canales-de-atencion/canales-digitales'

function NotFound() {
  return (
    <>
      <section className="p-0 block bg-[#f9fafa] justify-center items-center h-[80vh] md:flex">
        <div className="max-md:flex max-md:justify-center">
          <img src={require('../img/404.png')} alt="404" width={650} />
        </div>
        <div>
          <h1>Ooops... </h1>
          <h2>No se encontró la página solicitada.</h2>
          <p>Regresa a la página principal: <Link className={linkCls} to='/'>Inicio</Link></p>
          <p>Explora todas las secciones: <Link className={linkCls} to='/mapa-del-sitio'>Mapa del Sitio</Link></p>
          <p>Conoce nuestras herramientas de autodiagnóstico: <Link className={linkCls} to='/diagnosticos'>Diagnósticos</Link></p>
          <p>¿Necesitas ayuda? <a className={linkCls} href={CANALES_URL} target="_blank" rel="noopener noreferrer">Contáctanos</a></p>
        </div>
      </section>
    </>
  )
}

export default NotFound
